import moment from 'moment-timezone';
import { ISO_DATE_TIME_FORMAT } from '../../../constants/constant';

export const unmaskPostalCode = (postalCode: string): string => {
  if (postalCode && postalCode !== '') {
    return postalCode?.replace(/\D/g, '');
  }
  return '';
};

export const maskPostalCode = (postalCode: string): string => {
  if (postalCode && postalCode !== '') {
    const cleanedPostalCode = postalCode?.replace(/\D/g, '');
    if (cleanedPostalCode?.length <= 5) {
      return cleanedPostalCode;
    } else {
      return `${cleanedPostalCode?.substring(0, 5)}-${cleanedPostalCode?.substring(5)}`;
    }
  }
  return '';
};

export const unmaskPhoneNumber = (phoneNumber: string): string => {
  if (phoneNumber && phoneNumber !== '') {
    return phoneNumber?.replace(/\D/g, '');
  }
  return '';
};

export function maskPhoneNumber(phoneNumber: string): string {
  let formattedPhoneNumber = '';
  if (phoneNumber && phoneNumber !== '') {
    const cleanedPhoneNumber = phoneNumber?.replace(/\D/g, '');
    formattedPhoneNumber = cleanedPhoneNumber;
    if (cleanedPhoneNumber.length > 6) {
      formattedPhoneNumber = `(${cleanedPhoneNumber?.substring(0, 3)}) ${cleanedPhoneNumber?.substring(
        3,
        6,
      )}-${cleanedPhoneNumber?.substring(6)}`;
    } else if (cleanedPhoneNumber.length > 3) {
      formattedPhoneNumber = `(${cleanedPhoneNumber?.substring(0, 3)}) ${cleanedPhoneNumber?.substring(3, 6)}`;
    }
  }
  return formattedPhoneNumber;
}

export const unmaskCardNumber = (maskedCardNumber: string): string => {
  if (maskedCardNumber && maskedCardNumber !== '') {
    return maskedCardNumber?.replace(/[\s-]/g, '');
  }
  return '';
};

export const formatExpirationYear = (expirationYear: string): string => {
  if (expirationYear && expirationYear !== '') {
    return expirationYear?.slice(-2);
  }
  return '';
};

export const formatDate = (dateString: string | undefined): string | undefined => {
  if (!dateString) return undefined;

  const dateObj = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = { month: 'long', day: 'numeric', year: 'numeric' };
  const formattedDate = dateObj.toLocaleDateString('en-US', options);

  return formattedDate;
};

export const formatCreditDate = (dateString: string): string => {
  if (!dateString) return '';

  const date = new Date(dateString);
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const day = ('0' + date.getDate()).slice(-2);
  const year = date.getFullYear().toString().slice(-2);
  return `${month}/${day}/${year}`;
};

export const formatDOB = (dob: string): string => {
  const inputValue = dob?.replace(/\D/g, '').slice(0, 8);
  let formattedValue = '';

  if (inputValue.length <= 2) {
    formattedValue = inputValue;
  } else if (inputValue.length <= 4) {
    formattedValue = `${inputValue.slice(0, 2)}/${inputValue.slice(2)}`;
  } else {
    formattedValue = `${inputValue.slice(0, 2)}/${inputValue.slice(2, 4)}/${inputValue.slice(4)}`;
  }
  return formattedValue;
};

export const maskCardNumber = (cardNumber: string): string => {
  const inputValue = cardNumber?.replace(/\D/g, '');
  let maskedValue = '';

  if (inputValue.length <= 4) {
    maskedValue = inputValue;
  } else if (inputValue.length <= 8) {
    maskedValue = inputValue?.slice(0, 4) + '-' + inputValue?.slice(4);
  } else if (inputValue.length <= 12) {
    maskedValue = inputValue?.slice(0, 4) + '-' + inputValue?.slice(4, 8) + '-' + inputValue?.slice(8);
  } else {
    maskedValue =
      inputValue?.slice(0, 4) +
      '-' +
      inputValue?.slice(4, 8) +
      '-' +
      inputValue?.slice(8, 12) +
      '-' +
      inputValue?.slice(12);
  }
  return maskedValue;
};

export const Format = (formatString: string, args?: Array<string>) => {
  let formattedString = formatString;
  if (args) {
    formattedString = formatString.replace(/\{(\d+)\}/g, function (matcher) {
      const match = matcher.match(/(\d+)/g);
      if (match?.[0]) {
        const index = parseInt(match[0]);
        if (args.length > index) {
          return args[index];
        }
      }
      return matcher;
    });
  }
  return formattedString;
};

export const getCurrentCentralTimeISOString = (): string => {
  return moment().tz('America/Chicago').format(ISO_DATE_TIME_FORMAT);
};

export const convertDateFormat = (inputDate: string, inputDateFormat: string, outputDateFormat: string) => {
  return moment(inputDate, inputDateFormat).format(outputDateFormat);
};

export const formatPhoneNumber = (phoneNumberString: string) => {
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  const match = cleaned.match(/(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return [match[1], '-', match[2], '-', match[3]].join('');
  }
  if (cleaned.length === 10) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  return phoneNumberString;
};

export const formatZipCode = (zipCodeString: string) => {
  if (!zipCodeString) return '';
  const cleaned = ('' + zipCodeString).replace(/\D/g, '');
  const match = cleaned.match(/(\d{5})(\d{4})$/);
  if (match) {
    if (match[2]) {
      return [match[1], '-', match[2]].join('');
    }
    return match[1];
  }
  const firstFiveDigits = cleaned.match(/\d{5}/);
  return firstFiveDigits ? firstFiveDigits?.[0] : '';
};

export const stripVariantSuffix = (id: string): string => {
  if (!id || typeof id !== 'string') return id;
  return id.replace(/-(C|P)$/, '');
};

export const renderProductUrl = (url: string): string => {
  if (!url || typeof url !== 'string') return url;
  return url.replace(/-(C|P)(\?.*)?$/, '$2');
};
